import CheckIcon from "assets/images/icon/cert/check.svg";
import VerifiedFileIcon from "assets/images/icon/cert/verified-file-blue.svg";
import { SideBarItemProps } from "types/route";

export const SIDEBAR_ITEM: SideBarItemProps[] = [
  {
    parent: "/dashboard/certificate/template",
    path: "/dashboard/certificate/template/list",
    title: "Cấp chứng nhận",
    icon: CheckIcon,
  },
  {
    parent: "/dashboard/certificate/issued",
    path: "/dashboard/certificate/issued/list",
    title: "Chứng nhận đã cấp",
    icon: VerifiedFileIcon,
  },
];
